<template>
  <div class="card" style="width: 500px">
    <header class="card-header">
      <p class="card-header-title" style="font-size: large">
        {{ i18n.createRole[iso] }}
      </p>
      <button
        class="card-header-icon"
        aria-label="more options"
        @click="$emit('close')"
      >
        <span class="icon">
          <i class="fas fa-times" aria-hidden="true"></i>
        </span>
      </button>
    </header>
    <div class="card-content" style="height: 500px; overflow: auto">
      <div class="content">
        <div class="columns is-multiline">
          <div class="column is-6">
            <b-field
              :label="`${i18n.name[iso]} - ${i18n.spanish[iso]}`"
              :label-position="labelPosition"
            >
              <b-input v-model="role.Nombre" maxlength="20"></b-input>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field
              :label="`${i18n.name[iso]} - ${i18n.english[iso]}`"
              :label-position="labelPosition"
            >
              <b-input v-model="role.NombreEn" maxlength="20"></b-input>
            </b-field>
          </div>

          <div class="column is-12">
            <b-field :label="i18n.createRole__type[iso]">
              <div class="block">
                <b-radio v-model="role.Tipo" name="name" native-value="user">
                  User
                </b-radio>
                <b-radio v-model="role.Tipo" name="name" native-value="staff">
                  Staff
                </b-radio>
                <b-radio v-model="role.Tipo" name="name" native-value="club">
                  Club
                </b-radio>
                <b-radio
                  v-model="role.Tipo"
                  name="name"
                  native-value="agency"
                  disabled
                >
                  Agency
                </b-radio>
              </div>
            </b-field>
          </div>

          <div class="column is-12" v-if="role.Tipo === 'staff'">
            <b-field :label="i18n.createRole__staff[iso]">
              <div class="block">
                <b-checkbox v-model="role.StaffModulos" native-value="renewals">
                  {{ i18n.renewals[iso] }}
                </b-checkbox>
                <b-checkbox
                  v-model="role.StaffModulos"
                  native-value="activations"
                >
                  {{ i18n.activations[iso] }}
                </b-checkbox>
              </div>
            </b-field>
          </div>

          <div class="column is-12" v-if="role.Tipo === 'club'">
            <b-field :label="i18n.createRole__club[iso]">
              <b-dropdown v-model="role.Clubes" multiple aria-role="list">
                <template #trigger>
                  <b-button type="is-primary" icon-right="menu-down">
                    Selected ({{ role.Clubes.length }})
                  </b-button>
                </template>

                <b-dropdown-item value="all" aria-role="listitem">
                  <span>{{ i18n.all[iso] }}</span>
                </b-dropdown-item>

                <b-dropdown-item
                  :value="club.Id"
                  aria-role="listitem"
                  v-for="club in clubes"
                >
                  <span>{{ club.Nombre }}</span>
                </b-dropdown-item>
              </b-dropdown>
            </b-field>
          </div>

          <div class="column is-12">
            <hr />
            <div class="level">
              <div class="level-left">
                <p class="title is-5">
                  {{ i18n.createRole__permissions[iso] }}
                </p>
              </div>
              <div class="level-right">
                <b-button
                  type="is-info"
                  size="is-small"
                  @click="isPermissionModalActive = true"
                >
                  Gestionar Permisos
                </b-button>
              </div>
            </div>

            <!-- List Selected Permissions -->
            <b-table
              :data="selectedPermissionObjects"
              :bordered="false"
              :striped="true"
              :narrowed="true"
            >
              <b-table-column field="Modulo" label="Modulo" v-slot="props">
                {{ props.row.Modulo }}
              </b-table-column>
              <!-- <b-table-column
                field="Descripcion"
                label="Descripción"
                v-slot="props"
              >
                {{
                  iso === "es" ? props.row.Descripcion : props.row.DescripcionEn
                }}
              </b-table-column> -->
              <b-table-column label="Action" v-slot="props" centered>
                <b-button
                  type="is-danger is-light"
                  size="is-small"
                  icon-right="delete"
                  @click="removePermission(props.row.Modulo)"
                ></b-button>
              </b-table-column>
              <template #empty>
                <div class="has-text-centered">
                  No hay permisos seleccionados
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>

    <!-- Permission Selection Modal -->
    <b-modal
      v-model="isPermissionModalActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <div class="modal-card" style="width: 600px; height: 80vh">
        <header class="modal-card-head">
          <p class="modal-card-title">Seleccionar Permisos</p>
          <button
            class="delete"
            aria-label="close"
            @click="isPermissionModalActive = false"
          ></button>
        </header>
        <section class="modal-card-body">
          <b-field>
            <b-input
              v-model="searchPermission"
              placeholder="Buscar permiso..."
            ></b-input>
          </b-field>
          <div
            v-for="permission in filteredPermissions"
            :key="permission._id"
            class="box"
            style="margin-bottom: 0.5rem; padding: 0.5rem"
          >
            <div class="columns is-vcentered is-mobile">
              <div class="column is-1">
                <b-checkbox
                  v-model="role.Permisos"
                  :native-value="permission.Modulo"
                  type="is-success"
                ></b-checkbox>
              </div>
              <div class="column">
                {{ permission.Modulo }}
              </div>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <b-button @click="isPermissionModalActive = false">Cerrar</b-button>
        </footer>
      </div>
    </b-modal>
    <footer class="card-footer">
      <a
        @click="$emit('close')"
        class="card-footer-item button is-danger is-outlined is-small"
        style="height: auto"
        ><b>{{ i18n.cancel[iso] }}</b></a
      >
      <a
        :class="`card-footer-item button is-success is-outlined is-small ${
          loading ? 'is-loading' : ''
        }`"
        style="height: auto"
        @click="create"
        ><b>{{ i18n.save[iso] }}</b></a
      >
      <!-- <a href="#" class="card-footer-item">Delete</a> -->
    </footer>
  </div>
</template>

<script>
import axios from "axios";
const API_URL = process.env.VUE_APP_API_URL;
import moment from "moment";
import i18n from "../../utils/i18n";
// import { permissions } from "../../utils/permissions"; // Deprecated in favor of DB permissions

export default {
  name: "VacancyBackofficeModalLogs",
  props: ["roleToEdit"],
  data() {
    return {
      labelPosition: "on-border",
      loading: false,
      clubes: [],
      permissions: [], // From DB
      availablePermissions: [],
      searchPermission: "",

      // Modals
      isPermissionModalActive: false,

      //i18n
      i18n,
      iso: null,

      //
      role: {
        Nombre: null,
        NombreEn: null,
        Tipo: null,
        Permisos: [],
        StaffModulos: [],
        Clubes: [],
        TarifaAgenciaFija: null,
        TarifaAgenciaVariable: null,
      },
    };
  },
  computed: {
    filteredPermissions() {
      if (!this.searchPermission) return this.permissions;
      return this.permissions.filter((p) => {
        const term = this.searchPermission.toLowerCase();
        return (
          p.Nombre?.toLowerCase().includes(term) ||
          p.NombreEn?.toLowerCase().includes(term) ||
          p.Modulo?.toLowerCase().includes(term) ||
          p.Descripcion?.toLowerCase().includes(term)
        );
      });
    },
    selectedPermissionObjects() {
      if (!this.role.Permisos || this.role.Permisos.length === 0) return [];
      // Assuming Permisos stores ID or Module string. The schema says 'ref: permissions' but user provided example earlier used Module string in utils.
      // However, usually refs are ObjectIds. Let's check how it's stored. The utils/permissions.js used string keys.
      // The schema says: Permisos: [{ type: String, trim: true, ref: 'permissions' }]
      // If it is a ref, it should be an ID. But the previous code used `mainItemModule` (string).
      // Let's assume for now we need to match what the backend expects.
      // If the backend expects IDs, we send IDs. If it expects Module strings, we send strings.
      // The Previous implementation used: `v-model="role.Permisos" :native-value="permission.mainItemModule"`
      // So it was storing Strings. Validating against the Schema provided: `Permisos: [{ type: String, trim: true, ref: 'permissions' }]`.
      // Mongoose refs are usually ObjectIds, but can be other types if _id is string.
      // I will assume for now we work with IDs if we are fetching from DB, OR we continue with Module strings if that's the architectural pattern.
      // BUT, since we are fetching from `/system/list-permissions`, we will get objects with `_id` and `Modulo`.
      // I will store the `_id` if that's the standard for refs, usually it is.
      // Wait, the previous code used `permission.mainItemModule` which suggests strings like "list-weeks".
      // I will stick to storing the `_id` of the permission if possible, OR the unique string if the system relies on that.
      // User Schema: `Modulo: { type: String, trim: true, unique: true }`.
      // I'll try to support both or check what `list-permissions` returns.
      // For safety, I'll store the `_id` in the selection.
      return this.permissions.filter((p) =>
        this.role.Permisos.includes(p.Modulo),
      );
    },
  },
  async created() {
    this.iso = localStorage.getItem("iso");
    this.$bus.on("change-iso", () => {
      this.iso = localStorage.getItem("iso");
    });

    await this.listClubes();
    await this.listPermissions();

    if (this.roleToEdit) {
      this.role = { ...this.roleToEdit };
      // Ensure Permisos is an array of IDs. If the backend returns objects, we extract IDs.
      // If backend returns populated array, we map to IDs.
      if (
        this.role.Permisos &&
        this.role.Permisos.length > 0 &&
        typeof this.role.Permisos[0] === "object"
      ) {
        this.role.Permisos = this.role.Permisos.map((p) => p.Modulo);
      }

      if (
        this.role.Clubes &&
        this.role.Clubes.length > 0 &&
        typeof this.role.Clubes[0] === "object"
      ) {
        this.role.Clubes = this.role.Clubes.map((c) => c.Id);
      }
    }
  },
  methods: {
    async create() {
      try {
        this.loading = true;
        const payload = {
          ...this.role,
          // Ensure we don't send extra fields if not needed, but spread is fine usually
        };

        if (this.role._id) {
          // Update
          await axios.put(
            `${API_URL}/system/update-role/${this.role._id}`,
            payload,
          );
          this.$buefy.toast.open({
            message: "Rol actualizado correctamente",
            type: "is-success",
          });
        } else {
          // Create
          payload.CreadoPor = localStorage.getItem("user") || "system";
          await axios.post(`${API_URL}/system/create-role`, payload);
          this.$buefy.toast.open({
            message: this.i18n.createRole__msg1[this.iso],
            type: "is-success",
          });
        }

        this.loading = false;

        this.$emit("refreshRoles");
        // this.$emit("refreshUsers"); // Only if needed
        this.$emit("close");
      } catch (err) {
        this.loading = false;
        console.log(err);
        let msg = "Error al guardar rol";
        if (err?.response?.data?.error) msg = err?.response?.data?.error;
        this.$buefy.toast.open({
          message: msg,
          type: "is-danger",
        });
      }
    },
    async listClubes() {
      try {
        const { data } = await axios.post(`${API_URL}/club/list`, {
          Activo: true,
        });
        this.clubes = data?.clubes || [];
      } catch (err) {
        console.log(err);
      }
    },
    async listPermissions() {
      try {
        const { data } = await axios.post(
          `${API_URL}/system/list-permissions`,
          {},
        );
        this.permissions = data?.permissions || [];
        // Fallback if structure is different, waiting to see API response implicitly by assuming standard structure
      } catch (err) {
        console.log(err);
        this.$buefy.toast.open({
          message: "Error al listar permisos",
          type: "is-danger",
        });
      }
    },
    togglePermission(permId) {
      const index = this.role.Permisos.indexOf(permId);
      if (index === -1) {
        this.role.Permisos.push(permId);
      } else {
        this.role.Permisos.splice(index, 1);
      }
    },
    removePermission(permId) {
      const index = this.role.Permisos.indexOf(permId);
      if (index !== -1) {
        this.role.Permisos.splice(index, 1);
      }
    },
  },
};
</script>
